var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgKickerDiscs = function SvgKickerDiscs(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 4,
    cy: 12.5,
    rx: 2.5,
    ry: 11,
    fill: "#3D50FC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 9,
    cy: 12.5,
    rx: 4.5,
    ry: 11,
    fill: "#D80C9A"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 15.5,
    cy: 12.5,
    rx: 8,
    ry: 11,
    fill: "#05A1C9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKickerDiscs);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI1IDI1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZWxsaXBzZSBvcGFjaXR5PSIwLjYiIGN4PSI0IiBjeT0iMTIuNSIgcng9IjIuNSIgcnk9IjExIiBmaWxsPSIjM0Q1MEZDIi8+CjxlbGxpcHNlIG9wYWNpdHk9IjAuNiIgY3g9IjkiIGN5PSIxMi41IiByeD0iNC41IiByeT0iMTEiIGZpbGw9IiNEODBDOUEiLz4KPGVsbGlwc2Ugb3BhY2l0eT0iMC42IiBjeD0iMTUuNSIgY3k9IjEyLjUiIHJ4PSI4IiByeT0iMTEiIGZpbGw9IiMwNUExQzkiLz4KPC9zdmc+Cg==";